// @vendors
import React from 'react';
const { formatText, FormattedText } = require('core/i18n').i18n;
import { withRouter } from 'react-router-dom';
const PropTypes = require('prop-types');
// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
// @constants
const { MYPROFILE_BROKER_CRYPTO_URL } = require('constants/index');
// @styles
import './brokerCryptoPGBanner.scss';

const iconBuildPortfolio = require('assets/icons/icon-crypto.svg');

class BrokerCryptoPGBanner extends React.Component {
  constructor(props) {
    super(props);
  }
  
  handleGoToCryptoLanding = () => {
    this.props.history.push(MYPROFILE_BROKER_CRYPTO_URL);
  };
  render() {
    return (
      <div className="broker-crypto-pg-banner__container">
        <div className="broker-crypto-pg-banner__content">
          <div className="broker-crypto-pg-banner__icon-box">
            <img src={iconBuildPortfolio} />
          </div>
          <div className="broker-crypto-pg-banner__title">
            <FormattedText value="broker-cryptoBanner_title" />
          </div>
        </div>
        <div className="broker-crypto-pg-banner__button">
          <OKButton onClick={() => this.handleGoToCryptoLanding()}>
            <FormattedText value="broker-cryptoBanner_CTA" />
          </OKButton>
        </div>
      </div>
    );
  }
}

BrokerCryptoPGBanner.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(BrokerCryptoPGBanner);
